export const trackingSessionIdSelector = ({trackingSessionId}) => trackingSessionId